import React from 'react';

const BackArrow = ({ color = 'currentColor', size = 20 }: { color?: string, size?: number }) => {
  return <svg width="11" height={size} viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 1 2 10.255l7.5 8.742" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>;
};

export default BackArrow;
